import "./__styles__/Marker.scss";
import React from "react";
import { Marker } from "react-map-gl/mapbox-legacy";
import { confirmValidCoordinates } from "common/utils/coordinates";

export default ({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) => {
  if (!confirmValidCoordinates({ latitude, longitude })) {
    return null;
  }

  return (
    <Marker latitude={latitude} longitude={longitude} offset={[0, -8]}>
      <span styleName="marker" />
    </Marker>
  );
};
